








































import Vue from "vue";
import donationSteps from "@/donationSteps";
import {Donation} from "@/interfaces/donation/donation";
import {RequestSession} from "@/interfaces/requestSession";
import { isMemoryGift } from '@/classes/DonationType';

export default Vue.extend({
  props: {
    showPreviousButton: Boolean,
    requestHasExternalAgent: Boolean
  },
  computed: {
    donation(): Donation {
      return this.$store.state.donation
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    currentStep() {
      return this.$store.state.currentStep
    },
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal === donationSteps.step.INFORMATION && (!isMemoryGift(this.donation.donationType.type) || this.requestHasExternalAgent)) {
          this.handleStepRemoval(oldVal)
        } else {
          this.$emit('addStep', donationSteps.step.INFORMATION)
        }
      },
      immediate: true
    }
  },
  methods: {
    handleStepRemoval(oldVal) {
      this.$emit('removeStep', donationSteps.step.INFORMATION)
      if (oldVal === donationSteps.step.INFORMATION + 1) {
        this.$emit('previousStep')
      } else {
        this.$emit('nextStep')
      }
    }
  }
})
;
